import { LitElement, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import '../components/SignupComponent';

@customElement('auth-modal')
export class AuthModal extends LitElement {
createRenderRoot() { return this }
  @state() open = false;

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('open-auth-modal', this.openModal);
  }

  disconnectedCallback() {
    window.removeEventListener('open-auth-modal', this.openModal);
    super.disconnectedCallback();
  }

  openModal = () => {
    this.open = true;
  }

  closeModal = () => {
    this.open = false;
  }

  render() {
    return html`
      <div class="${this.open ? 'fixed inset-0 z-40 backdrop-blur-sm bg-black/30' : 'hidden'}"></div>
      <dialog class="modal ${this.open ? 'modal-open' : ''} z-50">
        <div class="modal-box">
          <h3 class="text-lg font-bold">Sign Up To Continue</h3>
          <form method="dialog">
            <button class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" @click=${this.closeModal}>✕</button>
          </form>
          <signup-component
            @close-auth-modal=${() => this.closeModal()}
          ></signup-component>
        </div>
        <form method="dialog" class="modal-backdrop">
          <button @click=${this.closeModal}>close</button>
        </form>
      </dialog>
    `;
  }
}
